













































import { Component, Prop, Vue } from 'vue-property-decorator';
import ApiConnector from '@/logic/connector/ApiConnector'
import User from "../../logic/model/User";

@Component({
    name: "login",
})
export default class Login extends Vue{
    email:string = "";
    password:string = "";
    errorMessage:string = "";

    submit() {
        this.errorMessage = "";
        new ApiConnector().login(this.email,this.password).then( (user:User) => {
            this.$store.commit("setUser",user);
            this.$store.dispatch('fetchData');
                
            this.$router.push('/articles')
        }).catch(error => {
            this.errorMessage = error.response.data.error;
        })
    }

    mounted() {
        let connector = new ApiConnector();
        if (connector.hasToken()) {
            connector.logout()
        }
    }
}
